import React from 'react';
import PropTypes from 'prop-types';
import { PSPModuleFactory } from 'components/psp/PSPModuleFactory';
import { pageTypes } from 'config/pageTypes';

import './PSPSection.scss';

export const toKebabCase = (text) => {
	if (typeof text !== 'string') {
		return '';
	}
	return text.split(' ').splice(0, 4).join('-').toLowerCase();
};

export default function PSPSection({
	title = '',
	modules = [],
	background,
	noPaddingBottom,
	noPaddingTop,
	noPadding,
	pageType = pageTypes.PSP,
}) {
	// Use a slugified version of the title as the id
	const sectionId = toKebabCase(title);
	const safeModules = Array.isArray(modules) ? modules : [];

	const sectionClassName = [
		'psp-section',
		pageType === pageTypes.SGP &&
			safeModules[0]?.type &&
			`sgp-section-${safeModules[0].type}`,
		sectionId,
		background,
		noPaddingBottom && 'no-padding-bottom',
		noPaddingTop && 'no-padding-top',
		noPadding && 'no-padding',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<section
			className={sectionClassName}
			id={sectionId}
		>
			{safeModules.map((module, index) => {
				const moduleType = module.type;
				const heroClass =
					pageType === pageTypes.SGP
						? `${pageType.toLowerCase()}-${moduleType}`
						: moduleType;
				const moduleClasses = [heroClass];
				if (module.id) moduleClasses.push(toKebabCase(module.id));
				if (module.background) moduleClasses.push(module.background);

				return (
					<div
						key={module.id || `${module.type}-${index}`}
						className={moduleClasses.join(' ')}
					>
						<PSPModuleFactory
							type={module.type}
							props={module.props}
							pageType={pageType}
						/>
					</div>
				);
			})}
		</section>
	);
}

PSPSection.propTypes = {
	modules: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string,
	background: PropTypes.string,
	noPaddingBottom: PropTypes.bool,
	noPaddingTop: PropTypes.bool,
	noPadding: PropTypes.bool,
	pageType: PropTypes.oneOf([pageTypes.PSP, pageTypes.SGP]),
};
